var interf = {
    current:"topview",
    seatmap:{
        nodes_selected: []
    },
    topview:{
        nodes_selected: []
    },
    filtering:{
        ref : null,
        nodes : {
            sections: [],
            rows: [],
            seats: []
        }
    },
    navigation:{
        to: "",
        from: ""
    },
    window:{
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        animation: requestAnimationFrame(interfaceWindowLoop)
    },
    params:interfaceGetParams(window.location.href)
}

function interfaceIsMobile(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width()<620) {
        return true;
    } else {
        return false;
    }
}
function interfaceGetParams(url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
/*     if(params.v360){
        params.v360 = atob(params.v360)
    }
    if(params.search){
        params.search = atob(params.search)
    } */
	return params;
}

function interfaceMoveArrowsHideOnLimits(){
    if(viewer.limits) {
        if(viewer.limits.left_limit) {
            $("#move-left").addClass("hidden");
        }
        
        if(viewer.limits.right_limit) {
            $("#move-right").addClass("hidden");
        }
        
        if(viewer.limits.upper_limit) {
            $("#move-up").addClass("hidden");
        }
        
        if(viewer.limits.lower_limit) {
            $("#move-down").addClass("hidden");
        }
    }
    return null;
}

function interfaceMoveArrowsShow(){
    $("#move-up").removeClass("hidden");
    $("#move-down").removeClass("hidden");
    $("#move-left").removeClass("hidden");
    $("#move-right").removeClass("hidden");
    return null;
}
function interfaceMoveArrowsHide(){
    $("#move-up").addClass("hidden");
    $("#move-down").addClass("hidden");
    $("#move-left").addClass("hidden");
    $("#move-right").addClass("hidden");
    return null;
}

function interfaceReset(){
    interf = {
        current:"topview",
        seatmap:{
            nodes_selected: []
        },
        topview:{
            nodes_selected: []
        },
        filtering:{
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        },
        navigation:{
            to: "",
            from: ""
        },
        window:{
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            animation: requestAnimationFrame(interfaceWindowLoop)
        }
    }
}
function interfaceResetFiltering(){
    interf.filtering = {
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        }
}

function interfaceWindowLoop() {
    var h = window.innerHeight;
    var bh = h - ($("#header-wrap").innerHeight() + $("#topbar").innerHeight());
    if(interf.params.iframe && interf.params.iframe==='true'){
        bh = h - ($("#topbar").innerHeight());
    }
    if(interfaceIsMobile()){
        bh = bh-50;
    }
    $("#main-interface").css("height", bh);
    interf.window.animation = requestAnimationFrame(interfaceWindowLoop);

    if(typeof viewer !='undefined' && viewer.isLoaded() ){
        if(interfaceIsMobile()){
            dvmHideLabs();
            $("#interface-btns-mobile").removeClass("hidden");
            $(".interface-btns-desktop").addClass("hidden");
        }else{
            $("#interface-btns-mobile").addClass("hidden");
            $(".interface-btns-desktop").removeClass("hidden");
            dvmShowLabs();
        }

        if(interfaceGetCurrent()!='view3d'){
            breadcrumbsShowToggle();
        }

        if(!interfaceIsMobile() && viewer.scaling_factor > viewer.min_scaling_factor && interf.current != "view3d") {
            interfaceMoveArrowsShow()
        } else {
            interfaceMoveArrowsHide()
        }
        interfaceMoveArrowsHideOnLimits();
    }
}

function interfaceZoomHide(){
    $(".zoom-in-btn").addClass("hidden");
    $(".zoom-out-btn").addClass("hidden");
    return;
}

function interfaceZoomShow(){
    //if(!interfaceIsMobile()){
        $(".zoom-in-btn").removeClass("hidden");
        $(".zoom-out-btn").removeClass("hidden");
    //}
    return;
}

function interfaceMoveFSbtn(){
    if(interfaceIsMobile()){
        viewer_3d.interface.setInterfaceElementPosition("toggle-fullscreen","bottomcenter")
    }
    return;
}


function interfaceFSBtnShow(){
    $(".fs-btn").removeClass("hidden");
    return null;
}
function interfaceFSBtnHide(){
    $(".fs-btn").addClass("hidden");
    return null;
}
function interfaceHomeBtnShow(){
    $(".home-btn").removeClass("hidden");
    return null;
}
function interfaceHomeBtnHide(){
    $(".home-btn").addClass("hidden");
    return null;
}
function interfaceGalleryArrowsToggle(){
    $(".glide__arrow").removeClass("hidden");
    if(interfaceIsMobile()){
        $(".glide__arrow").addClass("hidden");
    }
    return null;
}

function interfaceSetCurrent(current){
    interf.current = current;
    return interf;
}

function interfaceGetCurrent(){
    return interf.current;
}

function interfaceViewer3DBtnsHide(){
    $(".viewer-btn").addClass("hidden");
    return null;
}

function interfaceBackBtnShow(){
    $(".back-btn").removeClass("hidden");
    return null;
}
function interfaceBackBtnHide(){
    $(".back-btn").addClass("hidden");
    return null;
}
function interfaceGalleryBtnHide(){
    $(".gallery-btn").addClass("hidden");
    return null;
}

function interfaceGalleryBtnShow(){
    $(".gallery-btn").removeClass("hidden");

    return null;
}

function interfaceMinimapHide(){
    $(".minimap").addClass("hidden")
    return null;
}

function interfaceMinimapShow(){
    $(".minimap").removeClass("hidden")
    return null;
}

function interfaceBreadcrumbsValueHide(element){
    $(".bread-crumbs "+element).addClass("hidden");
    return null;
}

function interfaceZoomSetTopview(){
    $(".zoom-btns-interface").addClass("ci-topview");
    $(".zoom-btns-interface").removeClass("ci-seatmap");
    return null;
}

function interfaceZoomSetSeatmap(){
    $(".zoom-btns-interface").removeClass("ci-topview");
    $(".zoom-btns-interface").addClass("ci-seatmap");
    return null;
}

function interfaceSetTopview(){
    viewer_3d.close();
    viewer_3d.reset();
    $("#viewer").removeClass("hidden");
    $("#view3d").addClass("hidden");
    interfaceBackBtnHide();
    interfaceMinimapHide();
    interfaceZoomSetTopview();
    interfaceZoomShow();
    interfaceBreadcrumbsValueHide(".section");
    interfaceBreadcrumbsValueHide(".rows");
    interfaceBreadcrumbsValueHide(".seat");
    $(".area").addClass("hidden");

    interfaceHomeBtnHide();
    interfaceFSBtnHide();
    interfaceGalleryBtnHide();
    interfaceNavigationHide();
    menuBtnShow();

    viewer_mini.scaling_factor = viewer_mini.min_scaling_factor;
    //viewer.scaling_factor = 1;

    breadcrumbsShowToggle();

    if(interfaceIsMobile()) {
        //interfaceZoomHide();
        interfaceMoveArrowsHide();
        viewer.scaling_factor = 2;
    }
    //interfaceTicketsMobileBtnHide();
    popoverDestroyAll();
    interfaceSetCurrent("topview");
}

function interfaceSetSeatmap(){
    viewer_3d.reset();
    viewer_3d.close();
    $("#viewer").removeClass("hidden");
    $("#view3d").addClass("hidden");
    interfaceViewer3DBtnsHide();
    dvmSeatmapSetStyles();
    interfaceBackBtnShow();
    menuClose();
    menuBtnHide();

    interfaceMoveFSbtn();
    interfaceFSBtnHide();
    interfaceZoomSetSeatmap();
    interfaceZoomShow();

    if(!interfaceIsMobile()) {
        breadcrumbsShowToggle();
    }
    //interfaceTicketsMobileBtnHide();
    interfaceSetCurrent("seatmap");
    return null;
}

function interfacesetViewer3D(node){
    interfaceGalleryArrowsToggle();
    $("#viewer").addClass("hidden")
    $("#view3d").removeClass("hidden");
    interfaceSetNodeBC(node);
    interfaceSetCurrent('view3d');
    menuBtnHide();
    interfaceBackBtnShow();

    //breadcrumbsHide
    return null;
}

// function interfaceGoBack(){
//     console.log(interfaceGetCurrent())
//     console.log(list.length)
//     if (interfaceGetCurrent() === "seatmap") {
//         if(list.length > 0) {
//             viewer.loadMap({
//                 venue_id: venue_id,
//                 map_id: list[list.length-1].id
//             })    
//             .then(onLoadD2MSuccess)
//             .catch(onLoadD2MError);
//             list.pop();

//         } else {
//             interfaceSetTopview();
//             viewer.loadMap({
//                 venue_id: venue_id,
//                 map_id: topview_id
//             })    
//             .then(onLoadD2MSuccess)
//             .catch(onLoadD2MError);
//             list.pop();
//         }
//     } else if (interfaceGetCurrent() === 'view3d') {
//         //interfaceSetCurrent("seatmap");
//         if(interf.seatmap.nodes_selected[0].type == 'seat'){
//             interfaceSetSeatmap();
//         }else{
//             interfaceGoBack();
//         }
//         list.pop();
//     }

//     popoverDestroyAll();
// }

function interfaceGoBack() {
    var pop = list.pop();
    
    if(list.length < 2) {
        interfaceHideSectionLabel();
        interfaceHideRowLabel();
        interfaceHideSeatLabel();
        interfaceMinimapHide();
    } else {
        interfaceMinimapShow();
        interfaceNavigationHide()
    }

    if(current_view === "map") {
        if(list.length === 0) {
            interfaceGoHome();
            return;
        }

        viewer.loadMap({
            venue_id: venue_id,
            map_id: pop
        })
        .then(onLoadD2MSuccess)
        .catch(onLoadD2MError);
    } else if(current_view === "view3d") {
        interfaceSetSeatmap();
        current_view = 'map';
    }
}

function interfaceGoHome(){
    list = [];
    interfaceHideSectionLabel();
    interfaceHideRowLabel();
    interfaceHideSeatLabel();
    $("#viewer").removeClass("hidden");
    $("#view3d").addClass("hidden");
    viewer.loadMap({
        venue_id: venue_id,
        map_id: topview_id
    })
    .then(onLoadD2MSuccess)
    .catch(onLoadD2MError);
}

function interfaceBCSetColours(){
    for(let type in filtering_typereferenced){
        var ft = filtering_typereferenced[type];
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);

        for(var i =0;i<ft.length;i++){

            if(interf.topview.nodes_selected.indexOf(ft[i])>-1){
                $(".bread-crumbs").find(".breadcrumbs-val").addClass(type);
                $("#top-guide").find(".section-lab").addClass(type);
                $("#top-guide").find(".row-lab").addClass(type);
                $("#top-guide").find(".seat-lab").addClass(type);
            }
        }
       // if(interf.topview.nodes_selected)
    }
}
function interfaceBCResetColours(){
    for(let type in filtering_typereferenced){
        $(".bread-crumbs").find(".breadcrumbs-val").removeClass(type);
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);
    }
    return null;
}

function interfaceGoViewer(){ 
    $(".gallery-btn").removeClass("hidden");
    $(".viewer360-btn").addClass("hidden");
    $(".fs-btn").removeClass("hidden");
    viewer_3d.gallery.toggleCurrentView();
    interfaceMinimapShow();
    interfaceHomeBtnShow();
    interfaceNavigationShow();
}

function interfaceGoGallery(){
    $(".gallery-btn").addClass("hidden");
    $(".viewer360-btn").removeClass("hidden");
    $(".fs-btn").addClass("hidden");
    viewer_3d.gallery.toggleCurrentView();
    interfaceHomeBtnHide();
    interfaceMinimapHide();
    interfaceNavigationHide();
    return null;
}

function interfaceSetNodeBC(obj) {
    $(".rows").addClass("hidden");
    $(".seat").addClass("hidden");
    $(".section").removeClass("hidden");
    $(".section-val").text(obj.id.split("_")[1]);

    var selected_nodes = viewer.getNodesByState("seat","selected");
    if(selected_nodes.length > 0){
        var seat_id = selected_nodes[0].id.split("_")[1].split("-");
        $(".rows").removeClass("hidden");
        $(".seat").removeClass("hidden");
        $(".section").removeClass("hidden");
        if(interf.filtering.ref && !interfaceIsMobile()){
            $("#top-guide").addClass("filtered");
            $(".section-lab").html("<span class='fa-slash sm-hidden'>/</span> Section");
        }
        $(".section-val").text(seat_id[0]);        
        $(".row-val").text(seat_id[1]);
        $(".seat-val").text(seat_id[2]);
    }
}

function interfaceShowSectionLabel() {
    $(".section").removeClass("hidden");
}

function interfaceHideSectionLabel() {
    $(".section").addClass("hidden");
}

function interfaceShowRowLabel() {
    $(".rows").removeClass("hidden");
}

function interfaceHideRowLabel() {
    $(".rows").addClass("hidden");
}

function interfaceShowSeatLabel() {
    $(".seat").removeClass("hidden");
}

function interfaceHideSeatLabel() {
    $(".seat").addClass("hidden");
}

function interfaceSetTicketsURL(url){
    if(url){
        //Set link URL
        $(".tickets-link").attr("href",url);
    }
    return null;
}

function interfaceTicketsMobileBtnHide(){
    $("#interface-btns-mobile .tickets-link").addClass("hidden");
    return null;
}

function interfaceTicketsMobileBtnShow(){
    $("#interface-btns-mobile .tickets-link").removeClass("hidden");
    return null;
}

function interfaceNavigationShow(){
    $(".navigation").removeClass("hidden"); 
}

function interfaceNavigationHide(){
    $(".navigation").addClass("hidden");
}

function interfaceSetNavigationReverse(){
    var aux = interf.navigation.to;
    interf.navigation.to = interf.navigation.from;
    interf.navigation.from  = aux;
    return interf.navigation;
}

function interfaceGetNavigation(){
    return interf.navigation
}

function interfaceSetNavigation(){
    // let current_mapid = viewer.getMapId();
    // if(navigation.outdoor[current_mapid]){
    //     let parent = navigation.indoor[current_mapid];
    //     let outdoor = parent.outdoor;
    //     interf.navigation.to = outdoor;
    //     interf.navigation.from = {id: current_mapid, title:parent.title};

    // }
    var navfromviewer = viewer_3d.indoor.getIndoorRelatedView();
    if(navfromviewer){
        var toObj = {
            id : navfromviewer.view_id,
            title : navfromviewer.label
        }
        interf.navigation.to = toObj;
        interf.navigation.from = {id: viewer_3d.getViewId(), title:"Volver al asiento"};
    }

    return interf.navigation
}

function interfaceSetIframe(){
    $("#header-wrap").addClass("hidden");
    $("#interface-wrap").removeClass("container");
}